import type { KeyboardEvent as ReactKeyboardEvent } from 'react';

/**
 * IME-safe Enter key check.
 * Returns true only when Enter is pressed AND no IME composition is active.
 * Prevents double-trigger on non-English keyboards (CJK, Vietnamese, etc.).
 */
export function isEnterKey(e: ReactKeyboardEvent): boolean {
  return e.key === 'Enter' && !e.nativeEvent.isComposing;
}

/**
 * Native DOM variant of isEnterKey for document.addEventListener handlers.
 */
export function isEnterKeyNative(e: KeyboardEvent): boolean {
  return e.key === 'Enter' && !e.isComposing;
}
